import { formatDistanceToNow } from 'date-fns';
import type { Language } from '../../i18n/translations';
import { DATE_LOCALES } from '../../lib/dateLocales';
import type { WorkflowExecutionRecord } from '../../lib/workflowsApi';
import type { Execution, ExecutionStatus } from './components/ExecutionRow';

const WORKFLOW_TYPE_KEYS: Record<string, string> = {
  linkedin_enrichment: 'workflow.types.linkedinEnrichment',
  linkedin_enrichment_direct: 'workflow.types.linkedinEnrichment',
  instagram_enrichment_direct: 'workflow.types.instagramEnrichment',
  web_search_contact: 'workflow.types.webSearchContact',
};

const STATUS_KEYS: Record<ExecutionStatus, string> = {
  success: 'common.statuses.success',
  partial_success: 'common.statuses.partialSuccess',
  failed: 'common.statuses.failed',
  running: 'common.statuses.running',
};

export function mapExecutionToRow(
  exec: WorkflowExecutionRecord,
  t: (key: string) => string,
  language: Language = 'en',
): Execution {
  const statusMap: Record<string, ExecutionStatus> = {
    running: 'running',
    success: 'success',
    partial_success: 'partial_success',
  };
  const status: ExecutionStatus = statusMap[exec.status] ?? 'failed';

  const durationStr = exec.durationMs == null ? '-' : `${(exec.durationMs / 1000).toFixed(1)}s`;

  const locale = DATE_LOCALES[language];
  const timestamp = formatDistanceToNow(new Date(exec.startedAt), {
    addSuffix: true,
    ...(locale && { locale }),
  });

  const typeKey = WORKFLOW_TYPE_KEYS[exec.workflowType];

  return {
    id: exec.id,
    workflowName: typeKey ? t(typeKey) : exec.workflowType,
    status,
    statusLabel: t(STATUS_KEYS[status]),
    timestamp,
    duration: durationStr,
    source: exec,
  };
}
